import http from "./http";

const RAW_API_BASE =
  process.env.REACT_APP_API_BASE || "https://api.scoriva.net/api";

  // process.env.REACT_APP_API_BASE || "https://localhost:7164/api";


const API_BASE = RAW_API_BASE.replace(/\/+$/, "");

// Date -> "yyyy-MM-ddTHH:mm"
const toLocalDateTimeString = (d) => {
  if (!d) return "";

  const dt = d instanceof Date ? d : new Date(String(d));

  if (Number.isNaN(dt.getTime())) return "";

  const pad = (n) => String(n).padStart(2, "0");

  return `${dt.getFullYear()}-${pad(dt.getMonth() + 1)}-${pad(dt.getDate())}T${pad(
    dt.getHours()
  )}:${pad(dt.getMinutes())}`;
};

export const newsApi = {
  getAll: () => http.get("/api/news"),

  getById: (id) => http.get(`/api/news/${id}`),

  getImageUrl: (id) => `${API_BASE}/news/${id}/image`,

  create: ({
    titleAz,
    titleEn,
    titleRu,
    contentAz,
    contentEn,
    contentRu,
    manualInsertedDate,
    youtubeLink,
    imageFile,
  }) => {
    const fd = new FormData();

    fd.append("titleAz", titleAz ?? "");
    fd.append("titleEn", titleEn ?? "");
    fd.append("titleRu", titleRu ?? "");

    fd.append("contentAz", contentAz ?? "");
    fd.append("contentEn", contentEn ?? "");
    fd.append("contentRu", contentRu ?? "");

    fd.append("youtubeLink", youtubeLink ?? "");

    const mid = toLocalDateTimeString(manualInsertedDate);

    if (mid) {
      fd.append("manualInsertedDate", mid);
    }

    if (imageFile) {
      fd.append("imageFile", imageFile);
    }

    return http.post("/api/news", fd, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
  },

  update: (id, payload) => {
    const fd = new FormData();

    if (payload.titleAz !== undefined) {
      fd.append("titleAz", payload.titleAz ?? "");
    }

    if (payload.titleEn !== undefined) {
      fd.append("titleEn", payload.titleEn ?? "");
    }

    if (payload.titleRu !== undefined) {
      fd.append("titleRu", payload.titleRu ?? "");
    }

    if (payload.contentAz !== undefined) {
      fd.append("contentAz", payload.contentAz ?? "");
    }

    if (payload.contentEn !== undefined) {
      fd.append("contentEn", payload.contentEn ?? "");
    }

    if (payload.contentRu !== undefined) {
      fd.append("contentRu", payload.contentRu ?? "");
    }

    if (payload.youtubeLink !== undefined) {
      fd.append("youtubeLink", payload.youtubeLink ?? "");
    }

    if (payload.manualInsertedDate !== undefined) {
      const mid = toLocalDateTimeString(payload.manualInsertedDate);

      if (mid) {
        fd.append("manualInsertedDate", mid);
      }
    }

    if (payload.imageFile) {
      fd.append("imageFile", payload.imageFile);
    }

    return http.put(`/api/news/${id}`, fd, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
  },

  remove: (id) => http.delete(`/api/news/${id}`),
};